import gql from 'graphql-tag';

export const GET_LOCATION_SECTOR_QUERY = gql`
   query LocationSectorsQuery(
    $id: ID!
  ) {
    locationSector(id: $id) {
      id
      name
      description
      archived
      createdAt
      location {
        id
        name
        address {
          formattedAddress
        }
      }
      archived
      createdAt
      locationEnvironments {
        id
        name
        qrCode
        description
        archived
        createdAt
      }
    }
  }
`;

export const GET_LOCATION_SECTOR_MAINTENANCES_QUERY = gql`
  query QueryLocationSectorGQL($id:ID!, $take: Int, $after: String) {
    locationSector(id: $id) {
      id
      maintenances (take: $take, after: $after) {
        pageInfo {
          startCursor
          endCursor
        }
        items {
          id
          number
          status
          openedAt
          firstVisitStartedAt
          scheduled {
            date
            time
          }
          company {
            id
            name
            avatarUrl
          }
          maintenanceType {
            id
            name
          }
        }
      }
    }
  }
`;

export const SEARCH_LOCATION_SECTORS_QUERY = gql`
  query LocationSectorsQuery (
    $where: LocationSectorWhereInput
    $orderBy: LocationSectorOrderByInput
    $limit: Int
    $offset: Int
  ) {
    locationSectors (where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        name
        description
        archived
        location {
          name
          id
          address {
            formattedAddress
          }
        }
        locationEnvironments {
          id
          name
          qrCode
          description
          archived
          createdAt
        }
        createdAt
      }
    }
  }
`;

export const SEARCH_LOCATION_SECTORS_WITH_ENVIRONMENTS_AND_EQUIPMENTS_QUERY = gql`
	query LocationSectorsWithEnvironmentsAndEquipmentsQuery (
		$where: LocationSectorWhereInput
		$orderBy: LocationSectorOrderByInput
		$limit: Int
		$offset: Int
	) {
		locationSectors (where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			totalCount
			items {
				id
				name
				description
				archived
				location {
					name
					id
					address {
						formattedAddress
					}
				}
				locationEnvironments {
					id
					name
					qrCode
					description
					archived
					createdAt
					locationSector {
						id
					}
					equipments {
						id
						name
						number
						notes
						archived
						imageUrl
						type {
							id
							name
						}
						location {
							id
						}
						locationSector {
							id
						}
						locationEnvironment {
							id
						}
						warranties {
							id
							name
							status
							coverageDurationDays
							extendedCoverageDurationDays
							extendedValue
							endDate
							startDate
							extendedEndDate
							value
							description
							archived
							createdAt
							updatedAt
							equipment {
								id
								name
							}
							maintenance {
								id
								number
							}
							template {
								id
								name
							}
							createdBy {
								id
								name
							}
							updatedBy {
								id
								name
							}
							companies {
								id
							}
							maintenancesTypes {
								id
								name
							}
						}
						warrantySummary {
							id
							status
							startDate
							endDate
							extendedEndDate
						}
					}
				}
				createdAt
        equipmentsWithoutEnvironment {
						id
						name
						number
						notes
						archived
						imageUrl
						type {
							id
							name
						}
						location {
							id
						}
						locationSector {
							id
						}
						locationEnvironment {
							id
						}
						warranties {
							id
							name
							status
							coverageDurationDays
							extendedCoverageDurationDays
							extendedValue
							endDate
							startDate
							extendedEndDate
							value
							description
							archived
							createdAt
							updatedAt
							equipment {
								id
								name
							}
							maintenance {
								id
								number
							}
							template {
								id
								name
							}
							createdBy {
								id
								name
							}
							updatedBy {
								id
								name
							}
							companies {
								id
							}
							maintenancesTypes {
								id
								name
							}
						}
						warrantySummary {
							id
							status
							startDate
							endDate
							extendedEndDate
						}
					}
			}
		}
	}
`;

export const CREATE_LOCATION_SECTOR_MUTATION = gql`
  mutation CreateLocationSector($input: CreateLocationSectorInput!) {
    createLocationSector (input: $input) {
      id
      name
      description
      location {
        name
        id
      }
      archived
      createdAt
    }
  }
`;

export const UPDATE_LOCATION_SECTOR_MUTATION = gql`
  mutation UpdateLocationSector($input: UpdateLocationSectorInput!) {
    updateLocationSector (input: $input) {
      id
      name
      description
      location {
        name
        id
      }
      archived
      createdAt
    }
  }
`;
